import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import BusinessGrowthPlans from '../pages/BusinessGrowthPlans';
import { Reveal } from '../components/motion';
import { OperatingModelSection } from './sections';

export default function PricingPage() {
  return (
    <>
      <section className="page-hero">
        <Reveal className="page-hero-inner">
          <div className="section-tag">PRICING</div>
          <h1>Pick the layer your business needs now.</h1>
          <p>Every plan keeps the tools below it and adds the next operating layer. Upgrade when your lead volume, team, or locations grow.</p>
          <div className="page-hero-actions">
            <Link to="/free-tools" className="btn-ghost">Start with the free scan</Link>
            <Link to="/products" className="btn-ghost">See the full tool stack</Link>
          </div>
        </Reveal>
      </section>

      <BusinessGrowthPlans />

      <OperatingModelSection />

      <section className="home-cta">
        <div className="home-cta-inner">
          <div>
            <div className="section-tag">NOT SURE WHICH PLAN</div>
            <h2>Start on Launch and move up when it pays for itself.</h2>
            <p>Plans are enforced by the platform, so upgrading unlocks tools instantly and nothing you already created is lost.</p>
          </div>
          <div className="home-cta-actions">
            <Link to="/signup?plan=launch" className="btn-primary">Start on Launch <ArrowRight size={16} /></Link>
            <a href="mailto:host@loadedloaded.com?subject=Business%20Growth%20Consultation" className="btn-ghost">Talk to the team</a>
          </div>
        </div>
      </section>
    </>
  );
}
